import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { FolderContent, FolderType, IFolder, INewsArticle, IReport } from 'src/app/core/models/resource';
import { SchoolLibrary } from '../../models/library';

export const ResourceActions = createActionGroup({
  source: 'Resources',
  events: {
    // School / Folder navigation
    'Select School': props<{ schoolCode: string }>(),
    'Load Folders': props<{ schoolCode: string }>(),
    'Load Folders Success': props<{ schoolCode: string; folders: IFolder[] }>(),
    'Load Folders Failure': props<{ error: unknown }>(),
    'Select Folder': props<{ folderId: string }>(),
    'Load Folder Resources': props<{ folderId: string; folderType: FolderType }>(),
    'Load Folder Resources Success': props<{ folderId: string; resources: FolderContent[] }>(),
    'Load Folder Resources Failure': props<{ error: unknown }>(),

    // News
    'Load News Articles': emptyProps(),
    'Load News Articles Success': props<{ articles: INewsArticle[] }>(),
    'Load News Articles Failure': props<{ error: unknown }>(),

    // Reports
    'Load Student Reports': props<{ studentId: string }>(),
    'Load Reports Success': props<{ reports: Record<string, IReport[]> }>(),
    'Load Reports Failure': props<{ error: unknown }>(),
  },
});
//==============================================================================================================================

export const LibraryActions = createActionGroup({
  source: 'Library Page',
  events: {
    'Load School Library': props<{ schoolCode: string }>(),
    'Hydrate Libraries': props<{ libraries: SchoolLibrary[] }>(),
    'Clear Libraries': emptyProps(),
    'Load School Library Failure': props<{ error: string; statusCode: number }>(),
  }
});
